import {
  DETAILED_DATA_GRID_CLASS_NAME,
  DETAILED_SMALL_TEXT_DATA_GRID_CLASS_NAME,
  FOLIO_CELL_CLASS_NAME,
} from '../../constants/data-grid';
import { DEFAULT_LINK_CLASS_NAME } from '../../constants/link';
import FingoMuiDataGrid, { detailedDataGrid } from '../../fingo/components/MuiDataGrid';

const SORT_ICON_SIZE = 18;

const detailedFolioLink = ({ theme }) => ({
  [`& .MuiDataGrid-cell.${FOLIO_CELL_CLASS_NAME} .${DEFAULT_LINK_CLASS_NAME}`]: {
    color: theme.palette.secondary.main,
    textDecorationColor: theme.palette.secondary.main,
  },
});

const detailedHeader = () => ({
  '& .MuiDataGrid-columnHeaderTitleContainer .MuiTypography-root': {
    fontWeight: 500,
    lineHeight: '20px',
  },
  '& .MuiDataGrid-sortIcon': {
    fontSize: SORT_ICON_SIZE,
  },
});

const selectionParams = ({ theme }) => ({
  theme,
  selectedRowColor: theme.palette.gray.A300,
  selectedCheckboxColor: theme.palette.secondary.main,
});

const MuiDataGrid = {
  ...FingoMuiDataGrid,
  styleOverrides: {
    ...FingoMuiDataGrid.styleOverrides,
    root: ({ theme }) => {
      const base = FingoMuiDataGrid.styleOverrides.root({ theme });
      return {
        ...base,
        [`&.${DETAILED_DATA_GRID_CLASS_NAME}`]: {
          ...detailedDataGrid(selectionParams({ theme })),
          ...detailedHeader(),
          ...detailedFolioLink({ theme }),
        },
        [`&.${DETAILED_SMALL_TEXT_DATA_GRID_CLASS_NAME}`]: {
          ...detailedDataGrid({ ...selectionParams({ theme }), smallText: true }),
          ...detailedHeader(),
          ...detailedFolioLink({ theme }),
        },
      };
    },
  },
};

export default MuiDataGrid;
